import { render, staticRenderFns } from "./VTurbineStops.vue?vue&type=template&id=3bcdb5e8&scoped=true&"
import script from "./VTurbineStops.vue?vue&type=script&lang=js&"
export * from "./VTurbineStops.vue?vue&type=script&lang=js&"
import style0 from "./VTurbineStops.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VTurbineStops.vue?vue&type=style&index=1&id=3bcdb5e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdb5e8",
  null
  
)

export default component.exports